import { Reducer } from 'redux';
import {
  VerifyCompanyState,
  VerifyCompanyActionTypes,
  VERIFY_COMPANY_INPROGESS,
  VERIFY_COMPANY_SUCCESS,
  VERIFY_COMPANY_FAILURE,
} from './types';
import * as Bixby from '$/core';

const initialState: VerifyCompanyState = {
  isLoading: false,
  error: '',
  success: false,
  tokenInvalid: false,
};

const verifyCompanydReducer: Reducer<VerifyCompanyState> = (
  state = initialState,
  action: VerifyCompanyActionTypes
): VerifyCompanyState => {
  switch (action.type) {
    case VERIFY_COMPANY_INPROGESS:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case VERIFY_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenInvalid: action.payload === false,
        success: action.payload,
      };
    case VERIFY_COMPANY_FAILURE:
      return {
        ...state,
        error: Bixby.API.getErrorMessage((action.payload || {}) as Error),
        isLoading: false,
        success: false,
        tokenInvalid: true,
      };
    default:
      return state;
  }
};
export default verifyCompanydReducer;
